import { Skeleton } from '@/shared/components/ui/skeleton';

export const EngagementsBannerSkeleton = () => (
  <div className="bg-gradient-to-br from-[#3d6560]/60 to-[#5a8b84]/60 rounded-lg p-6 animate-pulse">
    <div className="flex items-center justify-between">
      <div className="space-y-3">
        <Skeleton className="h-5 w-64 bg-white/20" />
        <Skeleton className="h-4 w-40 bg-white/20" />
        <Skeleton className="h-4 w-48 bg-white/20 mt-2" />
      </div>
      <div className="text-right space-y-2">
        <Skeleton className="h-12 w-28 bg-white/20" />
        <Skeleton className="h-4 w-36 bg-white/20" />
      </div>
    </div>
  </div>
);

export const KPICardsSkeleton = ({ count = 4 }: { count?: number }) => (
  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
    {Array.from({ length: count }).map((_, i) => (
      <div key={i} className="bg-white rounded-lg border border-gray-200 p-6">
        <div className="flex items-start justify-between mb-4">
          <Skeleton className="h-4 w-24" />
          <Skeleton className="h-10 w-10 rounded-lg" />
        </div>
        <Skeleton className="h-8 w-20 mb-2" />
        <Skeleton className="h-4 w-28" />
      </div>
    ))}
  </div>
);

export const ChartSkeleton = ({ height = 'h-[300px]' }: { height?: string }) => (
  <div className="bg-white rounded-lg border border-gray-200 p-6">
    <div className="space-y-2 mb-6">
      <Skeleton className="h-5 w-40" />
      <Skeleton className="h-4 w-56" />
    </div>
    <Skeleton className={`w-full rounded ${height}`} />
  </div>
);

export const MapSkeleton = () => (
  <div className="bg-white rounded-lg border border-gray-200 p-6">
    <div className="flex items-start justify-between mb-4">
      <div className="space-y-2">
        <Skeleton className="h-5 w-48" />
        <Skeleton className="h-4 w-36" />
      </div>
      <div className="text-right space-y-2">
        <Skeleton className="h-8 w-16" />
        <Skeleton className="h-3 w-24" />
      </div>
    </div>
    <Skeleton className="h-[440px] w-full rounded" />
  </div>
);

export const LeaderboardSkeleton = () => (
  <div className="bg-white rounded-lg border border-gray-200 p-6">
    <div className="space-y-2 mb-6">
      <Skeleton className="h-5 w-64" />
      <Skeleton className="h-4 w-44" />
    </div>
    <div className="flex items-center justify-between gap-4 mb-4">
      <Skeleton className="h-9 w-64 rounded-md" />
      <Skeleton className="h-4 w-20" />
    </div>
    <div className="space-y-0">
      <Skeleton className="h-10 w-full" />
      {Array.from({ length: 5 }).map((_, i) => (
        <Skeleton key={i} className="h-14 w-full mt-1" />
      ))}
    </div>
  </div>
);

export const BreakdownsSkeleton = () => (
  <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
    <ChartSkeleton height="h-[280px]" />
    <ChartSkeleton height="h-[280px]" />
  </div>
);
